<div id="mask" class="" style="display: block; opacity: 0.8;"></div>
<div id="first_window" class="modalWindow anonymous-modal"
  style="top: 50%; left: 50%; display: block; position: fixed; transform: translate(-50%, -50%);" >
  <div class="modal-header clearfix" aria-labelledby="gdpr-model" role="dialog" aria-modal="true">
    <div class="width100 bold-txt" id="gdpr-model">
      {{ Header }}
      <div style="position: absolute; top: 8px; right: -5px;" class="fr txt-right close-icon close_modal"
        (click)="Close()" tabindex="0" aria-label="Close" role="button" (keydown)="CloseKeyboard($event)"></div>
    </div>
  </div>
  
  <!-- GDPR Message -->
  <div class="modal-body" style="text-align: left;">
    <div  *ngIf="(GDPRData.ContactPersonName != null && GDPRData.ContactPersonName != '') ||
    (GDPRData.ContactPersonDesignation != null && GDPRData.ContactPersonDesignation != '') ||
    (GDPRData.ContactPersonAddress != null && GDPRData.ContactPersonAddress != '') ||
    (GDPRData.ContactPersonEmailAddress != null && GDPRData.ContactPersonEmailAddress != '') ||
    (GDPRData.ContactPersonTelePhoneNo != null && GDPRData.ContactPersonTelePhoneNo != '') ||
    (GDPRData.ContactPersonMobileNo != null && GDPRData.ContactPersonMobileNo != '')"  class="contact-person-details">
      <div
       class="cpd-title">Data Policy Contact</div>

      <div class="cpd-name-addr">
        <div *ngIf="GDPRData.ContactPersonName != null && GDPRData.ContactPersonName != ''">{{GDPRData.ContactPersonName}}</div>
        <div *ngIf="GDPRData.ContactPersonDesignation != null && GDPRData.ContactPersonDesignation != ''">{{GDPRData.ContactPersonDesignation}}</div>
        <div *ngIf="GDPRData.ContactPersonAddress != null && GDPRData.ContactPersonAddress != ''">{{GDPRData.ContactPersonAddress}}</div>
      </div>

      <div class="cpd-mail-contact">
        <div *ngIf="GDPRData.ContactPersonEmailAddress != null && GDPRData.ContactPersonEmailAddress != ''" class="cpd-mc-item mail">
          <div class="cpd-mc-image"></div>
          <div class="cpd-mc-text">{{GDPRData.ContactPersonEmailAddress}}</div>
        </div>
        <div *ngIf="GDPRData.ContactPersonTelePhoneNo != null &&  GDPRData.ContactPersonTelePhoneNo != ''" class="cpd-mc-item contact">
          <div class="cpd-mc-image"></div>
          <div class="cpd-mc-text">{{GDPRData.ContactPersonTelePhoneNo}}</div>
        </div>
        <div *ngIf="GDPRData.ContactPersonMobileNo != null && GDPRData.ContactPersonMobileNo != ''" class="cpd-mc-item mobile">
          <div class="cpd-mc-image"></div>
          <div class="cpd-mc-text">{{GDPRData.ContactPersonMobileNo}}</div>
        </div>
      </div>
    </div>

    <div [innerHTML]="GDPRData.GDPRData| headerFooterHtml">

    </div>
  </div>
</div>